<template>
  <el-dialog
    class="commonDialog clickLight"
    title="选择人员"
    :visible.sync="open"
    width="1500px"
    append-to-body
    :before-close="closeDialog"
    :close-on-click-modal="false"
  >
    <el-row :gutter="24">
      <!--部门数据-->
      <el-col :span="6" :xs="24">
        <div class="head-container" style="height: 70vh; overflow: auto">
          <el-tree
            :data="deptOptions"
            :props="defaultProps"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            ref="tree"
            node-key="deptId"
            default-expand-all
            highlight-current
            @node-click="handleNodeClick"
          />
        </div>
      </el-col>
      <!-- 人员数据 -->
      <el-col :span="12" :xs="24">
        <el-input
          v-model="queryParams.name"
          placeholder="请输入姓名"
          style="width: 70%; margin-right: 20px"
          @keyup.enter.native="handleQuery"
        />
        <el-button type="primary" icon="el-icon-search" size="medium" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="medium" @click="resetQuery">重置</el-button>
        <el-table
          ref="multipleTable"
          height="484"
          v-loading="loading"
          :data="userList"
          row-key="userId"
          @selection-change="handleSelectionChange"
        >
          <el-table-column :reserve-selection="true" type="selection" width="50" align="center" />
          <el-table-column label="姓名" align="center" prop="name" :show-overflow-tooltip="true" />
          <el-table-column label="手机号码" align="center" prop="phone" width="120" />
        </el-table>

        <pagination
          v-show="total > 0"
          :total="Number(total)"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
        />
      </el-col>
      <!-- 已勾选的人员数据 -->
      <el-col :span="5" :xs="24" style="height: 548px; overflow-y: auto">
        <div style="margin-bottom: 15px; display: flex; justify-content: space-between; align-items: center">
          <div>
            已选人员(<span style="color: #1890ff">{{ selectLists.length }}</span
            >)
          </div>
          <el-button type="text" @click="clearAll">清空</el-button>
        </div>
        <div style="margin: 28px" v-if="selectLists.length > 0">
          <div
            v-for="(item, index) in selectLists"
            :key="index"
            style="margin-bottom: 15px; display: flex; justify-content: space-between"
          >
            <span>{{ item.name }}</span>
            <span>{{ item.phone }}</span>
          </div>
        </div>
      </el-col>
    </el-row>

    <span slot="footer" class="commonDialog-footer">
      <el-button type="primary" @click="distribeHttp">确 定</el-button>
      <el-button @click="closeDialog">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import axios from 'axios'
export default {
  name: 'selectInitiator',
  components: {
    // checkbox,
  },
  data() {
    return {
      selectLists: [],
      deptId: '', // 部门ID
      // 用户表格数据
      userList: [],
      // 总条数
      total: 0,
      // 遮罩层
      loading: true,
      queryParams1: {
        companyId: this.companyId,
      },
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        name: undefined,
        // phonenumber: undefined,
        // status: undefined,
        deptId: null,
        companyId: this.companyId,
      },
      // 部门名称
      name: undefined,
      // 部门树选项
      deptOptions: undefined,
      defaultProps: {
        children: 'children',
        label: 'deptName',
      },
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false,
    },
    open: {
      type: Boolean,
      required: true,
      default: false,
    },
    // 勾选人员 数组
    list: {
      type: Array,
      default: [],
    },
    // 公司ID
    companyId: {
      type: String,
      default: () => '',
    },
    url: {
      type: String,
      default: () => '',
    },
    checkedList: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.getDeptTree()
    this.getList()
    this.$nextTick(() => {
      this.list.forEach((row) => {
        this.$refs.multipleTable.toggleRowSelection(row, true) // 回显
      })
    })
  },
  methods: {
    /** 查询用户列表 */
  async getList() {
      this.loading = true
      this.queryParams.companyId = this.companyId
    await axios({
        // url: this.url + "/OA/getUserList",
        url: this.url + '/system/personnel/list',
        method: 'get',
        params: this.queryParams,
      }).then((res) => {
        this.userList = res.data.rows
        this.total = res.data.total
        this.loading = false
        this.$nextTick(() => {
          this.checkoutAllFun()
        })
      })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      var selectionList = []
      selection.forEach((e) => {
        selectionList.push({
          userId: e.userId,
          dptmntName: e.dptmntName,
          companyId: e.companyId,
          deptId: e.deptId,
          sex: e.sex,
          name: e.name,
          phone: e.phone,
          platformId: this.$route.query.platformId,
        })
      })

      this.selectLists = selectionList
      // let data=_.uniq(this.selectLists);
      // console.log(data,22);
      // // 去掉重复勾选的数据
      // // TODO: 这里唯一值使用的name，后续看是否更改为userId，需要后端在接口/system/personnel/list增加userId字段
      // this.selectLists =data;
      // console.log(selectionList,11);
    },

    // 多选框回显勾选状态
    checkoutAllFun() {
      // TODO: 这里唯一值使用的name，后续看是否更改为userId, 同上
      // 构建用户 唯一值 映射表，减少重复计算
      const userIdMap = {};
      this.userList.forEach((item) => {
        userIdMap[`${item.userId}`] = item;
      });
      // 遍历 this.list 并回显选中项
      this.list.forEach((row) => {
        const user = userIdMap[`${row.userId}`];
        if (user) {
          this.$refs.multipleTable.toggleRowSelection(user, true); // 回显
        }
        this.list=[];
      })
    },
    /** 查询部门下拉树结构 */
    getDeptTree() {
      axios({
        // url: this.url + "/OA/treeList?companyId=" + this.companyId,
        url: this.url + '/system/dept/treeList?companyId=' + this.companyId,
      }).then((res) => {
        if (res.data.code == 200) {
          this.deptOptions = res.data.data
        }
      })
    },
    // 筛选节点
    filterNode(value, data) {
      if (!value) return true
      return data.userId.indexOf(value) !== -1
    },
    // 节点单击事件
    handleNodeClick(data) {
      // console.log(data)
      this.queryParams.deptId = data.deptId
      this.handleQuery()
      this.$nextTick(() => {
        this.checkoutAllFun()
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams.deptId = null
      this.queryParams.name = null

      this.handleQuery()
    },

    // 清空
    clearAll() {
      this.list = []
      this.$refs.multipleTable.clearSelection()
    },
    // 关闭弹窗
    closeDialog() {
      this.$emit('update')
      this.$emit('open', false)
    },

    // 确定按钮
    distribeHttp() {
      if (this.selectLists.length <= 0) {
        this.$message({
          type: 'warning',
          message: '请选择人员',
        })
        return
      } else {
        this.$emit('sendList', this.selectLists)
        this.$emit('update')
        this.$emit('open', false)
      }
    },
  },
}
</script>

<style lang="less" scoped>
//去掉横向滚动条
/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}

.treeWrap {
  padding: 20px 30px 10px 30px;

  .titleTree1 {
    color: #333333;
    font-size: 14px;
    padding-left: 16px;
    margin-top: 8px;
    border: 1px solid #e5e5e5;
    border-bottom: none;
    height: 40px;
    line-height: 40px;
  }
  .treeLeft1 {
    overflow: hidden;
    border: 1px solid #e5e5e5;
    border-right: none;
    height: 480px;
    overflow-y: auto;
    .tabType {
      padding: 20px 14px 15px 14px;
      display: flex;
      .button {
        flex: 1;
        border: 1px solid #e5e5e5;
        text-align: center;
        height: 28px;
        line-height: 28px;
        font-size: 14px;
        color: #333;
        border-radius: 4px 0px 0px 4px;
      }
      .button:nth-child(2) {
        border-radius: 0px 4px 4px 0px;
        border-left: 0;
      }
      .checked {
        background-color: #1890ff;
        color: #fff;
      }
    }
    .organization,
    .roleList {
      .departmentBox {
        padding: 0 14px;
        display: inline-block;
        white-space: nowrap;
        .content {
          display: inline-block;
          width: 300px;
          overflow: hidden;
          .structureBox {
            display: inline-block;
            white-space: nowrap;
            .structure {
              display: inline-block;
              .iconfont {
                font-size: 14px;
              }
              .active {
                color: #1890ff;
              }
            }
          }
        }
      }
      .listBox {
        .listItem {
          padding: 0 14px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .icon-youjiantou {
            font-size: 14px;
            color: #999;
          }
        }
        .listItem:hover {
          background-color: #f7f7f7;
        }
      }
      .textNoDate {
        text-align: center;
        line-height: 370px;
      }
    }
  }
  .treeRight {
    overflow: hidden;
    border: 1px solid #e5e5e5;
    height: 460px;
    padding: 20px 28px 0 20px;
    overflow-y: auto;
    .tableFather1 {
      &.textNoDate {
        text-align: center;
      }
      .noData {
        line-height: 460px;
      }
    }
    .selected {
      .role,
      .department,
      .person {
        margin-bottom: 20px;
        .title {
          font-size: 14px;
          color: #999;
          margin-bottom: 12px;
        }
        .content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
          font-size: 14px;
          color: #333;
          .icon-liucheng_bohui {
            font-size: 14px;
            color: #f6747d;
            cursor: pointer;
          }
        }
      }
      .person {
        margin-bottom: 0;
        .imgBox {
          display: flex;
          align-items: center;
          .name {
            margin-left: 6px;
          }
        }
      }
    }
  }
  .text {
    font-size: 14px;
    color: #333333;
    margin-bottom: 12px;
  }
  .userLogo {
    font-size: 20px;
    color: #666;
    border-radius: 50%;
    vertical-align: bottom;
  }
  img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    vertical-align: bottom;
  }
}

/deep/.el-dialog__footer {
  // padding-bottom: 40px;
}
/* 定义滚动条样式 */
::-webkit-scrollbar {
  width: 6px;
  // height: 6px;
  background-color: transparent;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.1);
  border-radius: 10px;
  background-color: rgba(240, 240, 240, 0.1);
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  margin-right: 10px;
  border-radius: 10px;
  box-shadow: inset 0 0 0px rgba(240, 240, 240, 0.5);
  background: #bfbfbf;
}

/deep/ .el-dialog {
  margin-top: 2vh !important;
}

/deep/ .pagination-container {
  margin-top: 0;
}
</style>
